import React from 'react';
import './HtmlElement.scss';

const HtmlElement = props => {
  const {
    description,
    htmlId,
    width,
    height,
    backgroundColor,
    color,
    borderRadius,
    padding,
  } = props;

  return (
    <div
      id={htmlId}
      className="text-hotspot__html-wrapper"
      style={{
        width: width || 2048,
        height: height || 1024,
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: -1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        backgroundColor: backgroundColor || '#FFFFFFF2',
        borderRadius: borderRadius || 20,
        padding: padding || 40,
        color: color || 'black',
      }}
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
};

export default HtmlElement;
